<script setup lang="ts">
const switchLocalePath = useSwitchLocalePath();
const { locale, locales } = useI18n();
const localePinned = useCookie<string | null>("storefront_locale_pinned", {
  maxAge: 60 * 60 * 24 * 365,
  sameSite: "lax",
});

interface Props {
  class?: string;
  size?: number | string;
  rounded?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: "size-9 lg:size-10",
  class: "rounded-full",
  rounded: "rounded-full",
});

interface DropdownItem {
  label: string;
  class?: string;
  click?: () => void;
  [key: string]: unknown;
}

const languages = ref<DropdownItem[][]>([]);
const isOpen = ref<boolean>(false);

const availableLocales = computed(() =>
  locales.value.filter((i) => i.code !== locale.value)
);

const pickLocale = (code?: string) => {
  if (!code) return;
  localePinned.value = code;
  window.location.href = switchLocalePath(code);
};

languages.value[0] = availableLocales.value?.map((lang) => ({
  label: lang?.name,
  class: "justify-end",
  click: () => pickLocale(lang?.code),
}));

watch(availableLocales, () => {
  languages.value[0] = availableLocales.value?.map((lang) => ({
    label: lang?.name ?? "",
    class: "justify-end",
    click: () => pickLocale(lang?.code),
  }));
});
</script>

<template>
  <UDropdown v-model:open="isOpen" :items="languages" :ui="{ width: 'w-25' }">
    <UButton
      :ui="{ rounded: props.rounded }"
      color="white"
      class="font-medium justify-center"
      :class="[props.class, props.size]"
      :padded="false"
      :label="locale === 'ar' ? 'ع' : locale?.toUpperCase()"
    />
  </UDropdown>
</template>
